export default __webpack_public_path__ + "static/media/corazon.9836de92.svg";